module.exports = __webpack_public_path__ + "media/icons/deal-6b94e146.png";